import { Button, Typography, Spin } from 'antd';
import Table from '../TableResizable';
import { Backspace, Print } from '@mui/icons-material';
import {  Box ,Button as ButtonI} from '@mui/material';
import { useAuthUser } from '../../Services/Auth/sessionAuth';
import { useNavigate } from 'react-router-dom';
import * as React from "react";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import i18next from 'i18next';
import IosShareIcon from '@mui/icons-material/IosShare';
import Data from '../../Data/Data.json'
import PageNotFound from '../../Pages/PageNotFound';
import formatNumber from '../../Functions/Traitement/FormatNumber';
import Utilisateur from '../../Models/Utilisateur';
import Logo from "../../Res/greenLogo.png"
import ReformatNumber from '../../Functions/Traitement/ReformatNumber';

const { NumberToLetter } = require("convertir-nombre-lettre");

const PrintAvisOp = () => {
    
    //
    const [tab, setTab] = React.useState(localStorage.getItem(Data.LocalVariable.tabAvisOpe) ? JSON.parse(localStorage.getItem(Data.LocalVariable.tabAvisOpe) + "") : null as any)
    const navigate = useNavigate();
    // USER SESSION
    const auth = useAuthUser();
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
    //loading Boutton  
    const [loading, setLoading] = React.useState(false);

    const _exporter = React.createRef<ExcelExport>();

    const exportExcel = () => {
        if (!_exporter.current) {
            return;
        }
        setLoading(true);
        _exporter.current.save();
    };

    const handleExport = () => {
        setLoading(false);
    }
    // 
    setTimeout(() => {
        if (tab == null) {
            navigate("/")
        }
    }, 2000)

    return (
        <div><br />
            {tab ?
                <>
                    <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                        <Box className='backBtnt' zIndex={2} onClick={() => {
                               switch(tab?.P){
                                case "H":{ navigate("/transaction/Historique/" + tab?.form?.NUMCPT); break }
                                case "S":{ navigate("/SituationClient/" + tab?.form?.NUMCLI); break }
                             }
                              }}><Backspace /></Box>
                        <ExcelExport data={tab?.record}  fileName= {"AvisOperation"+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"}  ref={_exporter} onExportComplete={handleExport}>
                            <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} />
                            <ExcelExportColumn field="Date De Valeur" title="DEDEVR" />
                            <ExcelExportColumn field="LIBELL" title="Libelle" />
                            <ExcelExportColumn field="MONTANT" title="Montant" />
                            <ExcelExportColumn title="Beneficiare" field="NBENEF" />
                        </ExcelExport>
                        
                        <Box className={"preview_print"} marginLeft={'5%'}>
                            <Box className={"title"} display={"flex"} fontStyle={"inherit"}>
                                <img className='printLogo' src={Logo} width={80} />
                                <Typography style={{ textAlign: 'center', marginLeft: '35%' }} className='textTitle'><b>AVIS  D 'OPERATION DE  {tab?.record[0].MONTANTCREDIT !== '0' ? "CREDIT" : tab?.record[0].MONTANTDEBIT !== '0' ? "DEBIT" : ''} :  {tab?.record[0]?.REPECE}</b></Typography >
                                <hr className='hide' />
                                <Box display={'flex'} gap={'2em'}  marginLeft={'30%'}>
                                    <Button title='Imprimer ( ctrl + p )' onClick={() => { window.print() }} icon={<Print />} size='large' className='bt_add' type="ghost" htmlType="button" block  ></Button>
                                    {/* <ButtonI onClick={exportExcel}  className="NotVisiblePrint"  variant='outlined' size='small' color='success' startIcon={<IosShareIcon />}  > Excel </ButtonI> */}
                                </Box>
                            </Box><br />
                            <Box display={"flex"} fontStyle="inherit">
                                <Box width={"40%"} >
                                    <Box width={"120%"} display={"flex"}><Typography>Agence : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{user.codage}</b> {user.agence}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Client : </Typography><Typography style={{ marginLeft: '4%' }} ><b>{tab?.form?.NUMCLI} </b> {tab?.form?.lib_NUMCLI}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Compte : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{tab?.form?.NUMCPT} </b>{tab?.form?.lib_NUMCPT}</Typography></Box>
                                    <hr />
                                </Box>
                                <Box style={{ marginLeft: '10%' }}>
                                    <Box width={"120%"} display={"flex"}><Typography >{"Imprimé par " + user.codage + " - " + user.nomuti + " le " + (new Date(Date.now())).toLocaleDateString(i18next.language) + " à " + (new Date(Date.now())).toLocaleTimeString(i18next.language)}</Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Adresse : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{tab?.form?.NumDomCli} </b></Typography></Box>
                                    <Box width={"120%"} display={"flex"}><Typography>Boite Postale : </Typography><Typography style={{ marginLeft: '2%' }} ><b>{tab?.form?.adrPostal} </b></Typography></Box>
                                </Box>
                            </Box>
                            <Table size='small' showHeader bordered={true} pagination={false} columns={tab?.columns} dataSource={tab?.record} />
                            <Box display={"flex"} sx={{ marginLeft: '10%' }} gap={5} >
                                <Typography style={{ fontSize: '150%' }}> <b>Arrete Le Présent Avis à la somme de : </b> <b>{tab?.record[0].MONTANTCREDIT != 0 ? NumberToLetter(ReformatNumber(tab?.record[0].MONTANTCREDIT)) : NumberToLetter(ReformatNumber(tab?.record[0].MONTANTDEBIT)) + " "} </b> <span style={{ fontSize: '90%' }}>{tab.form.lib_CDDEVS ? tab.form.lib_CDDEVS : " "}</span>   </Typography>
                                {/* <Typography > <b>Total  / Nombre Crédit : </b> <b>{tab?.form?.TotalCrebit + " "} {tab.form.CDDEVS ? tab.form.CDDEVS : " "}</b> / {tab?.form?.NbrCrebit}</Typography> */}
                            </Box  >
                            <Box sx={{ marginLeft: '35%', marginBottom: '10%' }}>
                                <hr></hr>
                                <Typography style={{ textAlign: 'center',fontSize:'200%' }}  > <b>Signature</b></Typography>
                            </Box>
                        </Box>
                    </Spin>
                </>
                :
                <PageNotFound message={"Nothing to print"} backLink={"/"} texttButton={"Back to Loan Simulator"} />}
        </div>
    );
};

export default PrintAvisOp;